import styled from "styled-components";

export const PaddedWrapper = styled.div`
  margin: 64px 24px;
  width: 576px;

  .file-loader {
    margin: 24px 0;
  }

  .drop-zone-wrapper {
    width: 100%;
  }
`;

export const EmptyAttachmentWrapper = styled.div`
  height: 294px;
  width: 294px;
  left: 989px;
  top: 467px;
  border-radius: 50%;
  background: linear-gradient(217.82deg, rgba(79, 129, 157, 0.1) 6.94%, rgba(249, 249, 249, 0) 90.56%);
`;

export const NoAttachmentsTextWrapper = styled.div`
  width: 240px;
  height: 19px;

  /* Work Sans / 16 Regular */
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;

  /* identical to box height */
  display: flex;
  align-items: center;
  text-align: right;

  /* Fill / Dark Gray */
  color: #5F6368;  
`;

export const ImageContainer = styled.div`
  text-align: center;
  display: block;
  margin-top: 65px;
`;

export const AttachmentHeader = styled.div`
  display:flex;
  flex-flow:row;
  align-items:center;
  justify-content:space-between;
`;

export const Title = styled.div`
  //styleName: Work Sans / 24;
  font-family: Work Sans;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 12px;
`;

export const StyledInfo = styled.div`
  //styleName: Work Sans /  16 Regular;
  font-family: Work Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
`;
